import logo from './logo.svg';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css'; // Import Bootstrap CSS
import Navigation from './components/navbar';
import { BrowserRouter as Router, Routes, Route, Navigate, Link, useNavigate } from "react-router-dom";
import Home from './components/home';
import About from './components/aboutme';
import Resume from './components/resume';
import Footer from './components/footer';
import Portfolio from './components/portfolio';

function App() {
  return (
    <div className="App">
      <Navigation/>
      <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/resume" element={<Resume />} />
          <Route path="/portfolio" element={<Portfolio />} />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      <Footer/>
    </div>
  );
}

export default App;
